import { type ReactElement, cloneElement } from 'react'

import { type IIconComponentProps } from './types'

export type IconElement = ReactElement

export const renderIcon = (
  icon: IconElement,
  defaults: IIconComponentProps = {}
): ReactElement => {
  if (!icon) {
    return null
  }

  const { className, ...rest } = defaults
  const iconProps = icon.props as { className?: string }
  const mergedClassName = [className, iconProps.className]
    .filter(Boolean)
    .join(' ')

  return cloneElement(icon, {
    ...rest,
    ...iconProps,
    ...(mergedClassName && { className: mergedClassName }),
  })
}
